import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    getDefaultChangeHistoryColumns,
} from 'app/shared-components/ChangeHistory'
import {
    ModificationFields,
} from 'app/shared-components/ChangeHistory/ChangeHistory.types'

type LaneGroupsExtendedModificationsFields = ModificationFields | 'entityNumber'

export const getLaneGroupLaneChangeHistoryColumns = (
    labelPrefixKeys: string[],
): RichTableColumns<LaneGroupsExtendedModificationsFields>[] => {
    return [
        {
            id: 'entityNumber',
            headerProps: {
                children: 'Lane',
            },
            mapCellProps: 'entityNumber',
        },
        ...getDefaultChangeHistoryColumns(labelPrefixKeys),
    ]
}

export const getLaneGroupLaneFeesChangeHistoryColumns = (
    labelPrefixKeys: string[],
): RichTableColumns<LaneGroupsExtendedModificationsFields>[] => {
    return [
        {
            id: 'entityNumber',
            headerProps: {
                children: 'Pricing',
            },
            mapCellProps: 'entityNumber',
        },
        ...getDefaultChangeHistoryColumns(labelPrefixKeys),
    ]
}
